import "./App.css";
import React, { Suspense, lazy, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/common";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Loader, { PageLoader } from "./components/Loader";

const Platform = lazy(() => import("./pages/Platform"));
const AITradeEngine = lazy(() => import("./pages/AITradeEngine"));
const Strategies = lazy(() => import("./pages/Strategies"));
const PaidStrategies = lazy(() => import("./pages/PaidStrategies"));
const Backtesting = lazy(() => import("./pages/Backtesting"));
const TradeTerminal = lazy(() => import("./pages/TradeTerminal"));
const TradeJournal = lazy(() => import("./pages/TradeJournal"));
const Pricing = lazy(() => import("./pages/Pricing"));
const Academy = lazy(() => import("./pages/Academy"));
const Community = lazy(() => import("./pages/Community"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Affiliate = lazy(() => import("./pages/Affiliate"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Login = lazy(() => import("./pages/Auth").then((m) => ({ default: m.Login })));
const Signup = lazy(() => import("./pages/Auth").then((m) => ({ default: m.Signup })));
const ForgotPassword = lazy(() => import("./pages/Auth").then((m) => ({ default: m.ForgotPassword })));

function App() {
  const [booting, setBooting] = useState(true);
  const [fading, setFading] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 900);
    const t2 = setTimeout(() => setBooting(false), 1450);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <div className="App">
      {booting && <Loader fading={fading} />}
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/platform" element={<Platform />} />
              <Route path="/ai-trade-engine" element={<AITradeEngine />} />
              <Route path="/strategies" element={<Strategies />} />
            <Route path="/paid-strategies" element={<PaidStrategies />} />
              <Route path="/backtesting" element={<Backtesting />} />
              <Route path="/trade-terminal" element={<TradeTerminal />} />
              <Route path="/trade-journal" element={<TradeJournal />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/academy" element={<Academy />} />
              <Route path="/community" element={<Community />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/affiliate" element={<Affiliate />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
